import './App.css';
import Footer from './component/Footer/Footer';
import Hero from './component/Hero/Hero';
import Programs from './component/Hero/programs/Programs';
import Join from './component/Join/Join';
import Plans from './component/Plans/Plans';
import Reasons from './component/Reason/Reasons';
import Testimonials from './component/Testimonials/Testimonials';


function App() {
  return (
    <div className="App">
          <Hero/>
          <Programs/>
          <Reasons/>
          <Plans/>
          
          <Testimonials/>
          <Join/>
          <Footer/>



          
          
    </div>
  );
}

export default App;
